import {
    getField,
    updateField
} from "vuex-map-fields"
import {
    ADD_ROW, CALCULATE_ROW, RESET_FORM
} from "../../constant-types"
import { defaultSetFormMutation } from "../../default-method"

const getDefaultState = () => {
    return {
        rows: [getDefaultRowState()]
    }
}

const getDefaultRowState = () => ({
    id: '',
    type: 'goods', // as default 
    code: '',
    category_id : '',
    status_can_expire: false,
    name: '',
    price_sell : 0,
    price_modal : 0,
    price_revenue : 0,
    unit_id : ''
})

export default ({
    namespaced: true, 
    // variable
    state: getDefaultState(),
    // must syncronous
    mutations: {
        [ADD_ROW](state) {
            state.rows.push(getDefaultRowState())
        },
        // calculate price
        [CALCULATE_ROW](state) {
            state.rows[0].price_revenue = state.rows[0].price_sell - state.rows[0].price_modal
        },
        [RESET_FORM](state) {
            Object.assign(state, getDefaultState())
        },
        ...defaultSetFormMutation,
        updateField

    },
    // can async
    actions: {

    },
    // call variable with custom display
    getters: {
        getField
    }
})